import { FC } from "react";

interface IStrengthStatisticsTable {
    strengthCards: any;
}

const StrengthStatisticsTable : FC<IStrengthStatisticsTable>= ({strengthCards}) => {
    
    if (!strengthCards)
        return <div></div>

    const simulationStrength = [
        { color: "#002D3C", title: strengthCards[0].description, description: strengthCards[0].information || ""},
        { color: "#FF00A7", title: strengthCards[1].description, description: strengthCards[1].information || ""},
        { color: "#53BD8B", title: strengthCards[2].description, description: strengthCards[2].information || ""},
        { color: "#40C2CD", title: strengthCards[3].description, description: strengthCards[3].information || ""},
        { color: "#FED100", title: strengthCards[4].description, description: strengthCards[4].information || ""}        
]

    return ( 
        <div className="full_screen center_horizontally_and_vertically">
           <div className="strength_statistics_table">
                {simulationStrength.map( (item: any, index: number) => {
                    return(
                        <div className="strength_statistics_table_row" key={index}>
                            <div className=" strength_statistics_table_title center_horizontally_and_vertically" style={{backgroundColor: `${item.color}`}}>
                                {item.title}
                            </div>
                            <div className="strength_statistics_table_description center_horizontally_and_vertically" style={{backgroundColor: `${index%2 ? "#fff" : "#e1e8f0"}` }}>
                                {item.description}
                            </div>
                        </div>
                    )
                })}
           </div>
        </div>
    )
}

export default StrengthStatisticsTable;